import { render } from "./email-sent.vue?vue&type=template&id=4ea56055&ts=true"
import script from "./email-sent.vue?vue&type=script&lang=ts"
export * from "./email-sent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__